export enum AccountType {
  CheckingAccount = 0,
  SavingsAccount = 1,
  SalaryAccount = 2
}
